import { registerSW } from "virtual:pwa-register";

import { App } from "./app.ts";
import { Game } from "./game.ts";
import { Input } from "./input/input.ts";
import { UI } from "./ui/ui.ts";

// Auto-update the PWA: the moment a new service worker is detected it
// activates and reloads immediately (registerType: "autoUpdate" in
// vite.config.ts, paired with skipWaiting/clientsClaim so it doesn't wait
// for every open tab to close). A home-screen bookmark is rarely closed and
// almost never does a fresh navigation, so the browser's own "check on
// load" isn't enough on its own — poll for a new version every 60s too.
const updateSW = registerSW({
  immediate: true,
  onRegisteredSW(_url, registration) {
    if (!registration) return;
    setInterval(() => {
      registration.update().catch(() => {});
    }, 60_000);
  },
  onNeedRefresh() {
    void updateSW(true);
  },
});

async function boot(): Promise<void> {
  const mount = document.getElementById("app");
  if (!mount) throw new Error("missing #app mount");

  const app = new App();
  await app.init(mount);

  const input = new Input(app.pixi.canvas, app.mapToArena);
  const ui = new UI(mount);
  const game = new Game(app, input, ui);
  game.run();
}

void boot();
